
import React from "react";

const services = [
  {
    icon: "ri-user-heart-line",
    title: "Individual Health Plans",
    description:
      "Customized private health insurance solutions tailored to your personal medical needs and budget. We compare plans from top carriers across Houston to find your perfect fit.",
    highlight: "Plans from $150/mo",
  },
  {
    icon: "ri-group-line",
    title: "Family Coverage",
    description:
      "Comprehensive family health insurance that protects every member. From pediatric care to preventive services, we ensure your Houston family is fully covered.",
    highlight: "Full family protection",
  },
  {
    icon: "ri-building-2-line",
    title: "Company Group Plans",
    description:
      "Attract and retain top talent with competitive group health insurance. We design employee benefit packages that work for Houston businesses of all sizes.",
    highlight: "Custom group rates",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "Medicare Supplements",
    description:
      "Navigate Medicare options with confidence. Our Houston consultants help seniors find the right supplement plans to fill coverage gaps and reduce out‑of‑pocket costs.",
    highlight: "Expert guidance",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Short‑Term Insurance",
    description:
      "Bridge coverage gaps with flexible short‑term private health insurance plans. Ideal for Houston residents between jobs or waiting for employer coverage to begin.",
    highlight: "Quick enrollment",
  },
  {
    icon: "ri-stethoscope-line",
    title: "Specialized Coverage",
    description:
      "Dental, vision, critical illness, and supplemental health insurance options. We help Houston individuals and families build complete protection beyond basic medical plans.",
    highlight: "Complete protection",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-12">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 text-brand-600 text-sm font-semibold tracking-wider uppercase mb-3">
            <span className="w-8 h-[2px] bg-brand-500"></span>
            Our Services
            <span className="w-8 h-[2px] bg-brand-500"></span>
          </span>
          <h4 className="text-4xl md:text-5xl font-display font-bold text-navy-900 mb-4">
            <a href="#services">Comprehensive Private Health Insurance Solutions</a>
          </h4>
          <p className="text-navy-500 text-base max-w-2xl mx-auto">
            As an independent broker in Houston, we compare private health insurance
            plans from multiple carriers to find the coverage that fits your life and
            budget.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <article
              key={index}
              className="bg-navy-50/50 rounded-xl p-8 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group cursor-pointer border border-transparent hover:border-brand-200 relative overflow-hidden"
            >
              <div className="absolute top-0 left-0 w-full h-1 bg-brand-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
              <div className="w-14 h-14 rounded-xl bg-brand-100 flex items-center justify-center mb-5 group-hover:bg-brand-500 transition-colors duration-300">
                <i
                  className={`${service.icon} text-2xl text-brand-600 group-hover:text-white transition-colors duration-300`}
                ></i>
              </div>
              <h3 className="text-xl font-display font-bold text-navy-900 mb-3">
                {service.title}
              </h3>
              <p className="text-navy-500 text-sm leading-relaxed mb-4">
                {service.description}
              </p>
              <span className="inline-flex items-center gap-1 text-brand-600 text-xs font-semibold bg-brand-50 px-3 py-1 rounded-full">
                <i className="ri-check-line text-sm"></i>
                {service.highlight}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
